import { Box, Button, Typography, Stack } from '@mui/material'
import { useState } from 'react'
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BioModal from './Modals/BiometricCaptureModal';
import LockerAuthentication from './Modals/lockerAuthenticationModal/LockerAuthentication';
import { DashInfoBox } from '../../components/styledComponent/DashCount';
import DashCount from '../../components/dashboard/DashCount';
import useFingerControl from '../../components/biometric/useFingerControl';

const VisitLogCount = ({ visitCount, refetch }: any) => {
    const [newVisitModal, setNewVisitModal] = useState<boolean>(false);
    const [endVisitModal, setEndVisitModal] = useState<boolean>(false);
    const [state, setState] = useState<any>({})

    const fingerControl = useFingerControl(setState)

    const handleClick = () => {
        fingerControl('enroll', 'ftrapi', 1)
    };
    return (
        <>
            <Box sx={{ background: "white", borderRadius: "5px", padding: "20px", flexGrow: "1", marginTop: "12px" }}>
                <Typography component="p" mb={1}>Today's Visit</Typography>
                <DashInfoBox>
                    <DashCount
                        icon={<CalendarViewMonthIcon sx={{ color: "white", fontSize: "30px" }} />}
                        color="rgba(47, 128, 237, 1)"
                        title="Total Visit Count"
                        value={visitCount.totalCount ?? 0}
                    />
                    <DashCount
                        icon={<CalendarViewMonthIcon sx={{ color: "white", fontSize: "30px" }} />}
                        color="	#BF40BF"
                        title="Ongoing Visit"
                        value={visitCount.onGoingCount ?? 0}
                    />
                    <DashCount
                        icon={<AccountCircleIcon sx={{ color: "white", fontSize: "30px" }} />}
                        color="#FFA629"
                        title="Completed Visitor"
                        value={visitCount.completedCount ?? 0}

                    />
                    <Stack spacing={1}>
                        <Button variant='contained' onClick={() => {
                            handleClick()
                            setNewVisitModal(true)
                        }} sx={{ fontSize: '10px', padding: "4px", minWidth: "100px" }} >
                            CHECK IN
                        </Button>
                        <Button variant='contained' onClick={() => { handleClick(); setEndVisitModal(true) }} color='error' sx={{ fontSize: '10px', padding: "4px", minWidth: "100px" }} >
                            CHECK OUT
                        </Button>
                    </Stack>
                </DashInfoBox>
            </Box>

            <BioModal fingerControl={fingerControl} open={endVisitModal} setOpen={setEndVisitModal} refetch={refetch} state={state} setState={setState} />
            <LockerAuthentication fingerControl={fingerControl} open={newVisitModal} setOpen={setNewVisitModal} refetch={refetch} state={state} setState={setState} />
        </>
    )
}

export default VisitLogCount
